export default __webpack_public_path__ + "static/media/discordiconBlack.ba664809.svg";